import { useEffect, useState } from 'react'

/** The value, settled: it changes only after `ms` without further changes. */
export const useDebounced = <T>(value: T, ms = 350): T => {
   const [settled, setSettled] = useState(value)
   useEffect(() => {
      const t = setTimeout(() => setSettled(value), ms)
      return () => clearTimeout(t)
   }, [value, ms])
   return settled
}
